// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__cwmkW","name":"ConsentHeader_name__18oRo","birthday":"ConsentHeader_birthday__1vw3A","skeleton":"ConsentHeader_skeleton__RLXtM"};